// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small-modal {
  display: flex;
  margin-bottom: 42px;
}

.modal-img {
  margin-right: 16px;
}

.card {
  flex-shrink: 0;
  border-radius: 12px;
  background: #fff;
  opacity: 1;
  padding: 0;
}

.card-header {
  display: flex;
  align-items: center;
  border-bottom: 0px !important;
  padding: 0;
}

.card-header-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
}

.card-header-content-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
}

.modal-footer.MuiDialogActions-root {
  min-height: 72px;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0 24px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/modals/smallModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".small-modal {\n  display: flex;\n  margin-bottom: 42px;\n}\n\n.modal-img {\n  margin-right: 16px;\n}\n\n.card {\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: #fff;\n  opacity: 1;\n  padding: 0;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  border-bottom: 0px !important;\n  padding: 0;\n}\n\n.card-header-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n}\n\n.card-header-content-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0;\n}\n\n.modal-footer.MuiDialogActions-root {\n  min-height: 72px;\n  display: flex;\n  align-items: center;\n  background: #fff;\n  padding: 0 24px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
